import { render, staticRenderFns } from "./TaskTracker.vue?vue&type=template&id=613bd14c&scoped=true"
import script from "./TaskTracker.vue?vue&type=script&lang=js"
export * from "./TaskTracker.vue?vue&type=script&lang=js"
import style0 from "./TaskTracker.vue?vue&type=style&index=0&id=613bd14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bd14c",
  null
  
)

export default component.exports